var entitiesGroups = [
    {
        label: Loc.g('Activité du collaborateur'),
        value: 'staffActivity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'nylasAccount'],
    },
    {
        label: Loc.g('Contact'),
        value: 'contact',
        entities: ['prospect', 'client', 'supplier', 'thirdcontact'],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        label: Loc.g('Facturation'),
        value: 'invoicing',
        entities: ['invoice', 'creditnote', 'proforma', 'order', 'delivery'],
    },
];

var entitiesTabs = [];

var defaultEntities = ['email', 'phonecall', 'annotation', 'event', 'task', 'nylasAccount'];

var forcedLabel = [];

export { entitiesGroups, entitiesTabs, defaultEntities, forcedLabel };
